import axios from "../../helpers/httpClient";

export default {
  requestProveedores: async ({ commit, state, dispatch }, obj) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const proveedores = await axios.get(`/information/private/management/consultaDatosProveedor`, {
        params: {
          perPage: (obj) ? obj.perPage : 40,
          currentPage: (obj) ? obj.currentPage : 1,
          dataFilter: (obj) ? obj.dataFilter : {}
        }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      // Stop Loader
      commit('SET_LOADER', false);

      if (proveedores.status === 200) {
        commit('SET_PROVEEDORES', proveedores.data.proveedores);
        commit('SET_PROVEEDORES_FILTROS', proveedores.data.proveedores);
        
        commit('SET_PROVEEDORES_EXPORT', proveedores.data.proveedores);
        commit('SET_PROVEEDORES_FILTERS_EXPORT', proveedores.data.proveedores);

        commit('SET_TOTAL_PROVEEDORES', proveedores.data.totalCoincidences);
      }

    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  requestProveedor: async ({ commit, state, dispatch }, id) => {
    try {
        // Start loader
        commit('SET_LOADER', true);

        const data = await axios.get(`/information/private/management/consultaProvedor`, {
            params: { id }}, {
            headers: { 'Content-Type': 'application/json' }
        });

        // Stop Loader
        commit('SET_LOADER', false);

        if (data.status === 200) {
          return data.data.proveedores
        }

    } catch (error) {
        // Stop Loader
        commit('SET_LOADER', false);

        console.log(error)
        if (error?.response) {
            console.log(error?.response)
            dispatch('activeMessageError', (error.response !== undefined)
                ? error?.response?.data?.message || error?.response?.data?.msg
                : 'ERROR'
            )
        } else {
            dispatch('activeMessageError', 'ERROR')
            console.log(error)
        }
        return
    }
},
  agregarProveedorVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const proveedores = state.proveedores
      const crearProveedorResponse = await axios.post("/information/private/management/crearProveedor", {
        ...payload,
      })

      // Stop Loader
      commit('SET_LOADER', false);

      if (crearProveedorResponse.status === 200) {
        proveedores.push(crearProveedorResponse.data.data)

        commit('SET_PROVEEDORES', proveedores);
        commit('SET_PROVEEDORES_FILTROS', proveedores);
        
        commit('SET_PROVEEDORES_EXPORT', proveedores);
        commit('SET_PROVEEDORES_FILTERS_EXPORT', proveedores);

        dispatch('activeMessageCorrect', crearProveedorResponse.data.message)
      }
    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  editarProveedorVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const proveedores = state.proveedores
      const editarProveedorResponse = await axios.post("/information/private/management/editarProveedor", {
        ...payload,
      })

      // Stop Loader
      commit('SET_LOADER', false);

      if (editarProveedorResponse.status === 200) {
        proveedores.forEach((data, index) => {
          if (data.Id_proveedor === editarProveedorResponse.data.data[0].Id_proveedor) {
            Object.assign(proveedores[index], editarProveedorResponse.data.data[0])
          }
        })

        commit('SET_PROVEEDORES', proveedores);
        commit('SET_PROVEEDORES_FILTROS', proveedores);
        
        commit('SET_PROVEEDORES_EXPORT', proveedores);
        commit('SET_PROVEEDORES_FILTERS_EXPORT', proveedores);

        dispatch('activeMessageCorrect', editarProveedorResponse.data.message)
      }
    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  eliminarProveedorVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const proveedores = state.proveedores
      const eliminarProveedorResponse = await axios.post("/information/private/management/eliminarProveedor", payload)

      // Stop Loader
      commit('SET_LOADER', false);

      if (eliminarProveedorResponse.status === 200) {
        const nuevosProveedores = proveedores.filter((proveedor) => proveedor.Id_proveedor !== payload.Id_proveedor)

        commit('SET_PROVEEDORES', nuevosProveedores);
        commit('SET_PROVEEDORES_FILTROS', nuevosProveedores);
        
        commit('SET_PROVEEDORES_EXPORT', nuevosProveedores);
        commit('SET_PROVEEDORES_FILTERS_EXPORT', nuevosProveedores);

        dispatch('activeMessageCorrect', eliminarProveedorResponse.data.message)
        return eliminarProveedorResponse
      }

    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },

  addProveedoresImport: async ({ commit, state, dispatch }, allProveedores) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const proveedores = state.proveedores
      
      const newProveedores = await axios.post(`/information/private/management/addProveedoresImport`, {
        allProveedores,
    })

      // Stop Loader
      commit('SET_LOADER', false);

      if (newProveedores.status === 200) {
        proveedores.push(newProveedores.data.data)

        commit('SET_PROVEEDORES', proveedores);
        commit('SET_PROVEEDORES_FILTROS', proveedores);
        
        commit('SET_PROVEEDORES_EXPORT', proveedores);
        commit('SET_PROVEEDORES_FILTERS_EXPORT', proveedores);

        dispatch('activeMessageCorrect', newProveedores.data.message)
        return 'ok'
      }
    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
}